import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

export const getCompletedPayments = (params: {
  dateFrom?: string;
  dateTo?: string;
  perPage?: number;
  page?: number;
} = {}) => {
  const snakeParams = camelToSnake(params);
  return api.get(`${BASE_URL}/api/v1/completed-payments`, { params: snakeParams });
};

export const getInvoiceBill = (invoiceId: number) => {
  return api.get(`${BASE_URL}/api/v1/completed-payments/invoices/${invoiceId}/bill`);
};

export const getInvoiceTransactions = (invoiceId: number) => {
  return api.get(`${BASE_URL}/api/v1/completed-payments/invoices/${invoiceId}/transactions`);
};

export const getAllocationReceipt = (allocationId: number) => {
  return api.get(`${BASE_URL}/api/v1/completed-payments/allocations/${allocationId}/receipt`);
};
